<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useUserSettingsStore } from '@/stores/userSettings'
import LangItem from './LangItem.vue'
import AvatarCard from '@/components/layout/AvatarCard.vue'
import Logo from './Logo.vue'

const authStore = useAuthStore()
const userSettingsStore = useUserSettingsStore()
const theme = ref(userSettingsStore.theme)
watch(
  () => userSettingsStore.theme,
  (newValue) => (theme.value = newValue),
)
</script>

<template>
  <header
    class="from-sidebar text-muted-foreground flex h-16 w-full items-center justify-between border-b bg-linear-to-r to-[#17467b] px-4 shadow-sm"
  >
    <!-- Left Side - Logo -->
    <div class="flex items-center">
      <Logo />
    </div>

    <!-- Right Side - Language & Avatar -->
    <div class="flex items-center gap-4">
      <LangItem :isTopRight="true" />
      <AvatarCard v-if="authStore.isLoggedIn" :isTopRight="true" />
    </div>
  </header>
</template>
